export enum EBARRING_STATUS {
    ACTIVE = "ACTIVE",
}

export interface IBarring {
    barringStatus?: EBARRING_STATUS;
    name: string;
    barringCode: string;
}
